module.exports = __webpack_public_path__ + "img/bicen-1.6e106071.gif";